import { Avatar } from "@mui/material";
import React from "react";
import Divider from "@mui/material/Divider";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";

const Beneficiaries = ({ img, name, accountNumber, isLast }) => {
  return (
    <>
      <div className="flex flex-row justify-between mb-2">
        <Avatar src={img} className="mr-4" />
        <div className="beneficiaries__details flex flex-col mr-auto">
          <div className="beneficiaries__name text-gray-500 text-sm font-medium">
            {name}
          </div>
          <div className="beneficiaries__account italic text-xs text-gray-500 font-semibold">
            Acc no. {accountNumber}
          </div>
        </div>
        <StarBorderOutlinedIcon />
      </div>
      {!isLast && (
        <Divider
          className="mb-1"
          flexItem
          variant="middle"
          sx={{
            backgroundColor: "white",
          }}
        />
      )}
    </>
  );
};

export default Beneficiaries;
